import { toast } from 'react-toastify';
import AxiosInstance, { ApiNoAuth } from './apiAdapter';

export const login = (userData: { username: string, password: string }) =>
  ApiNoAuth.post(`/auth/login`, userData)

export const refreshToken = async (data: {
  refreshToken: string;
  expiredToken: string;
}) =>
  ApiNoAuth.post(`/auth/refresh-token`, data)

export const verifyUserPassword = async (data: { password: string, sid: string }) =>
  ApiNoAuth.post(`/users/verify-password`, data)

export const logout = () =>
  AxiosInstance.post(`/auth/logout`)

export const forgotPassword = (data: { username: string }) =>
  ApiNoAuth.post(`/users/forgot-password`, data)

export const resetPassword = (body: {
  token: string,
  newPassword: string,
  confirmNewPassword: string
}) =>
  ApiNoAuth.put(`/users/reset-password`, body)

export const changePassword = (body: {
  oldPassword: string,
  newPassword: string
}) =>
  AxiosInstance.put(`/users/change-password`, body)

export const changePin = (body: {
  pin: string
}) =>
  AxiosInstance.put(`/users/change-pin`, body)

export const resendVerification = (data: { email: string }) =>
  ApiNoAuth.post(`/users/resend-verification`, data)

export const resendEmailVerification = (data: { email: string }) =>
  ApiNoAuth.post(`/user-registration/email-resend`, data)

export const confirmVerification = (data: { token: string }) =>
  ApiNoAuth.post(`/users/confirm-verification`, data)

export const verifyMobile = () =>
  AxiosInstance.post(`/user-registration/verify-mobile-number`)

export const validateMobile = (data: { otp: string }) =>
  AxiosInstance.post(`/users/validate-mobile`, data)

export const pinSetup = (pin: { pin: string }) =>
  AxiosInstance.post(`/users/pin-setup`, pin)

export const handleLogout = async (sessionExpired?: boolean) => {
  const query = sessionExpired ? "?userSession=1" : ""
  try {
    // logout without calling the endpoint
    // if (!withoutEndpoint) {
    //   await logout()
    // }
    localStorage.removeItem("sessionId")
    window.history.pushState("", "", `/login${query}`);
    window.history.go(0);
  } catch (error: any) {
    if (error.message === "Network Error") return toast.error("Please connect to a network")
    if (error.status === 500) {
      window.history.pushState("", "", `/login${query}`);
      window.history.go(0);
      return
    }
    toast.error(error?.response?.data?.message || 'Please try again, an error occured')
  }
}